import { useGetProductsV2Query } from '@/features/slice/products/product/productApiSlice';
import { useUrlFilter, useUrlPagination } from '@/hooks';

import { TQueryFilterParams } from '../../../../types';

export const useProductList = () => {
    const { page, limit } = useUrlPagination();
    const { debouncedSearchText, sortBy, sortOrder, getSearchFilter } =
        useUrlFilter();

    const brandId = getSearchFilter('brand_id');
    const genericId = getSearchFilter('generic_id');

    const queryParams: TQueryFilterParams = {
        page,
        limit,
        search: debouncedSearchText,
        sort_by: sortBy,
        sort_order: sortOrder,
    };

    if (brandId) {
        queryParams['brand_id'] = brandId;
    }

    if (genericId) {
        queryParams['generic_id'] = genericId;
    }

    const { data, isLoading, isFetching, isError, error, refetch } =
        useGetProductsV2Query(queryParams);

    return {
        data,
        isLoading,
        isFetching,
        isError,
        error,
        refetch,
    };
};
